<div class="overlay" [class.show]="isDetailsVisible" (click)="closeDetails()"></div>
<div class="product-details-panel" [class.open]="isDetailsVisible">
  <div class="panel-header">
    <ui-button type="outlined-gay" icon="close" iconSize="large" (click)="closeDetails()"></ui-button>
    <span class="title">{{ 'Catalogs.product_details.title' | translate }}</span>
  </div>

  <div class="content" *ngIf="selectedProduct">
    <div class="product-name">
      {{ selectedProduct.name }}
    </div>
    <div class="product-image" *ngIf="selectedProduct">
      <img [src]="baseUrl + '/' + allImages[currentImageIndex]" [alt]="selectedProduct.name" class="main-image"
        (error)="onImageError($event)" />

      <div class="image-thumbnails" *ngIf="allImages.length > 1">
        <button class="nav-btn" (click)="prevImage()">
          <img src="assets/icones/arrow-select-left.svg" alt="Previous" />
        </button>

        <div class="thumbnails-container">
          <img *ngFor="let img of allImages; let i = index" [src]="baseUrl + '/' + img" [alt]="selectedProduct.name"
            [class.active]="i === currentImageIndex" (click)="selectImage(i)" />
        </div>

        <button class="nav-btn" (click)="nextImage()">
          <img src="assets/icones/arrow-select-right.svg" alt="Next" />
        </button>
      </div>
    </div>
    <div class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.brand' | translate }}</div>
      <div class="detail-value">{{ selectedProduct.brand?.name || '--' }}</div>
    </div>
    <div class="detail-row description-row">
      <div class="detail-label">{{ 'Catalogs.product_details.description' | translate }}</div>
      <div class="detail-value">
        <div class="description-text" [class.expanded]="isDescriptionExpanded"
          [innerHTML]="selectedProduct?.description || '--'">
        </div>

        <button *ngIf="shouldShowToggle" class="show-more-btn" (click)="toggleDescription()">
          {{ isDescriptionExpanded ? 'Show less' : 'Show more' }}
        </button>
      </div>
    </div>

    <div class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.labels' | translate }}</div>
      <div class="detail-value">
        <ng-container *ngIf="selectedProduct?.tags?.length; else noLabels">
          <span class="chip gray-chip" *ngFor="let label of selectedProduct.tags">
            {{ label.name ?? label }}
          </span>
        </ng-container>
        <ng-template #noLabels>
          <span class="text-muted">--</span>
        </ng-template>
      </div>
    </div>

    <div class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.categories' | translate }}</div>
      <div class="detail-value">
        <ng-container *ngIf="selectedProduct?.categories?.length; else noCategories">
          <span class="chip gray-chip" *ngFor="let category of selectedProduct.categories">
            {{ category.name ?? category }}
          </span>
        </ng-container>
        <ng-template #noCategories>
          <span class="text-muted">--</span>
        </ng-template>
      </div>
    </div>
    <div class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.ean' | translate }}</div>
      <div class="detail-value">{{ selectedProduct.barcode || '--' }}</div>
    </div>

    <div class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.sku' | translate }}</div>
      <div class="detail-value">{{ selectedProduct.sku || '--' }}</div>
    </div>

    <!-- Detail panels list every identifier regardless of the tenant's primary
         code, so nothing is ever hidden from a user or from support (WB-7419). -->
    <div class="detail-row">
      <div class="detail-label">{{ 'product_code.erp_id' | translate }}</div>
      <div class="detail-value">{{ selectedProduct.erp_id || '--' }}</div>
    </div>

    <div class="go-to-product">
      <button class="go-to-btn" (click)="goToProduct()">
        <span>{{ 'Catalogs.product_details.go_to_product' | translate }}</span>
        <img src="assets/icones/arrow-link.svg" alt="arrow link" class="arrow-icon" />
      </button>
    </div>

    <hr class="separator" />

    <div class="section-title">{{ 'Catalogs.product_details.price' | translate }}</div>

    <div *ngIf="selectedProduct" class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.sales_price' | translate }}</div>
      <div class="detail-value">
        {{ selectedProduct.sales_price ?? '--' }} {{ getPriceCurrency(selectedProduct) }}
      </div>
    </div>

    <div *ngIf="selectedProduct" class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.cost' | translate }}</div>
      <div class="detail-value">
        {{ selectedProduct.cost ?? '--' }} {{ getPriceCurrency(selectedProduct) }}
      </div>
    </div>

    <div *ngIf="selectedProduct" class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.final_price' | translate }}</div>
      <div class="detail-value">
        {{
          (selectedProduct.final_price && selectedProduct.final_price > 0
          ? selectedProduct.final_price
          : selectedProduct.sales_price) ?? '--'
          | number:'1.2-2'
        }}
        {{ getPriceCurrency(selectedProduct) }}
      </div>
    </div>

    <div *ngIf="selectedProduct" class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.discount' | translate }}</div>
      <div class="detail-value">
        {{ selectedProduct.discount !== undefined ? (selectedProduct.discount / 100 | percent) : '--' }}
      </div>
    </div>

    <div *ngIf="selectedProduct && selectedProduct.cost !== undefined && selectedProduct.sales_price !== undefined"
      class="detail-row">
      <div class="detail-label">{{ 'Catalogs.product_details.margin' | translate }}</div>
      <div class="detail-value">
        {{ getMarginAmount(selectedProduct) | number:'1.2-2' }} {{ getPriceCurrency(selectedProduct) }}
        <span class="chip margin-chip">
          {{ getMarginPercent(selectedProduct) | number:'1.0-0' }}%
        </span>
      </div>
    </div>
  </div>
  <div class="panel-footer">
    <ui-button type="outlined-gay" label="{{ 'Catalogs.buttons.close' | translate | uppercase }}"
      (click)="closeDetails()"></ui-button>
    <div class="quantity-input-container">
      <button class="quantity-btn decrease" (click)="decreaseQuantity()">
        <img src="assets/icones/min-select.svg" alt="Decrease" />
      </button>

      <input type="number" [(ngModel)]="product!.quantity" (ngModelChange)="onQuantityChange($event)" min="0"
        class="quantity-input" />

      <button class="quantity-btn increase" (click)="increaseQuantity()">
        <img src="assets/icones/max-select.svg" alt="Increase" />
      </button>
    </div>
  </div>
</div>